var exports = {
  "AS": "x52a3aa3b--b0fb57--item",
  "DD": "x52a3aa3b--b0fb57--title",
  "VH": "x52a3aa3b--b0fb57--preview",
  "Sb": "x52a3aa3b--b0fb57--metro-item",
  "M3": "x52a3aa3b--b0fb57--metro-icon",
};

module.exports = exports;
